import { FC, PropsWithChildren, useContext } from 'react';

import {
  ErrorEventType,
  PaymentContextErrorEvent,
  PaymentContextProvider,
} from '@onlinepayments/payments-library';

import { APP, CHANNEL } from './config';
import { PayorderContext } from './PayorderContext';
import { fetchAuthToken } from './utils/auth';
import { getCountryAndLanguage } from './utils/localization';

export const PaymentLibraryContext: FC<PropsWithChildren> = ({ children }) => {
  const {
    contextState: {
      paymentContext: { contextId },
    },
    dispatchContext,
  } = useContext(PayorderContext);
  const { countryCode, languageCode } = getCountryAndLanguage();

  return (
    <PaymentContextProvider
      assetsBaseUrl={window.payorder.PAYMENT_ASSETS_BASE_URL}
      app={APP}
      channel={CHANNEL}
      baseUrl={window.payorder.IOPS_API_URL}
      languageCode={languageCode}
      countryCode={countryCode}
      clientId={window.payorder.API_CLIENT_ID}
      sentryEnvironment={window.payorder.APP_ENV}
      paymentContextId={contextId || ''}
      onError={(error: PaymentContextErrorEvent) => {
        if (error.type === ErrorEventType.PaymentCancelled) {
          dispatchContext({ type: 'RemoveContextIds' });
        }
      }}
      children={children}
      getAuthToken={fetchAuthToken}
    />
  );
};
